import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminHeader from '../../components/admin/AdminHeader';
import AdminEmptyPage from '../../pages/admin/AdminEmptyPage';

// Импорт страниц
import AdminLocationsManagement from '../../pages/admin/locations/AdminLocationsManagement';

import AdminCategoriesManagement from '../../pages/admin/categories_and_tags/AdminCategoriesManagement';
import AdminCategoriesList from '../../pages/admin/categories_and_tags/AdminCategoriesList';
import AdminCategoryAdd from '../../pages/admin/categories_and_tags/AdminCategoryAdd';
import AdminCategoryEdit from '../../pages/admin/categories_and_tags/AdminCategoryEdit';
import AdminTagsList from '../../pages/admin/categories_and_tags/AdminTagsList';
import AdminTagAdd from '../../pages/admin/categories_and_tags/AdminTagAdd';
import AdminTagEdit from '../../pages/admin/categories_and_tags/AdminTagEdit';

// Импорт страниц локаций
import AdminLocationsList from '../../pages/admin/locations/AdminLocationsList';
import AdminLocationAdd from '../../pages/admin/locations/AdminLocationAdd';
import AdminLocationEdit from '../../pages/admin/locations/AdminLocationEdit';

// Импорт страниц маршрутов
import AdminRoutesList from '../../pages/admin/routes/AdminRoutesList';
import AdminRouteAdd from '../../pages/admin/routes/AdminRouteAdd';
import AdminRouteEdit from '../../pages/admin/routes/AdminRouteEdit';

const AdminRoutes = () => {
  return (
    <>
      <AdminHeader />
      <div className="admin-content">
        <Routes>
          {/* Корневой путь админки - пустая страница */}
          <Route index element={<AdminEmptyPage />} />
          
          {/* Управление локациями/маршрутами */}
          <Route path="locations" element={<AdminLocationsManagement />}>
            <Route index element={<Navigate to="list" replace />} />
            <Route path="list" element={<AdminLocationsList />} />
            <Route path="add" element={<AdminLocationAdd />} />
            <Route path="edit/:id" element={<AdminLocationEdit />} />
            <Route path="routes" element={<AdminRoutesList />} />
            <Route path="routes/add" element={<AdminRouteAdd />} />
            <Route path="routes/edit/:id" element={<AdminRouteEdit />} />
          </Route>
          
          <Route path="categories" element={<AdminCategoriesManagement />}>
            <Route index element={<Navigate to="list" replace />} />
            <Route path="list" element={<AdminCategoriesList />} />
            <Route path="add" element={<AdminCategoryAdd />} />
            <Route path="edit/:id" element={<AdminCategoryEdit />} />
          </Route>

          <Route path="tags" element={<AdminCategoriesManagement />}>
            <Route index element={<Navigate to="list" replace />} />
            <Route path="list" element={<AdminTagsList />} />
            <Route path="add" element={<AdminTagAdd />} />
            <Route path="edit/:id" element={<AdminTagEdit />} />
            </Route>
        </Routes>
      </div>
    </>
  );
};

export default AdminRoutes;